import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useMemo, useRef, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';

import { Autosuggest, Button, ButtonDropdown, FileUpload, Form, FormField, Input, Link, Modal, Popover, RadioGroup, Select, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiFile, mdiFileCloud, mdiFileExcelBox, mdiFilePdfBox, mdiFilePowerpointBox, mdiFileWordBox, mdiFolderOutline, mdiFolderPlusOutline, mdiLockCheckOutline, mdiLockOpenAlertOutline, mdiZipBox } from '@mdi/js';
import Icon from '@mdi/react';
import Confirm from '../../../../components/extras/Confirm';
import Favorites from '../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemDocument, ItemFile, ItemFolder } from '../../../../resources/types';
import { buildBreadcrumbItems, fileToBase64, getCookie, getUrlVersion, getUser, setLoading } from '../../../commons/functions';

interface ItemBreadcrumbs {
  text: string;
  href: string;
}

interface FlatFolder {
  id: number;
  name: string;
  idFolder: number;
  idParent: number;
  isPublic: number;
  objects: number;
  type: string;
}

// Define the shape required by your Select component
interface SelectOption {
  label: string;
  value: number;
}

interface FolderSelectProps {
  folders: FlatFolder[];
  value?: number;
  onChange: (value: number) => void;
}
const root = "#masters/docs";
export const MastersDocsPage = () => {
  const { data, menu } = useGlobalState();



  const [documents, setDocuments] = useState<ItemDocument[]>([]);
  const [document, setDocument] = useState<ItemDocument | null>(null);
  const [folders, setFolders] = useState<ItemDocument[]>([]);
  const [aprovals, setAprovals] = useState<ItemDocument[]>([]);

  const [deleteFile, setDeleteFile] = useState<ItemDocument>();
  const [deleteFolder, setDeleteFolder] = useState<ItemFolder>();

  const [folder, setFolder] = useState<ItemFolder | null>(null);
  const [moveFile, setMoveFile] = useState<ItemFile | null>(null);
  const [moveFolder, setMoveFolder] = useState<ItemFolder | null>(null);
  const [file, setFile] = useState<ItemFile | null>(null);
  const [oFiles, setOFiles] = useState<any[]>([]);
  const [masterFolders, setMasterFolders] = useState<ItemDocument[]>([]);
  const [route, setRoute] = useState<ItemBreadcrumbs[]>([{ text: "Inicio", href: root }]);

  const [idFolder, setIdFolder] = useState<number>(0);
  const [keyword, setKeyword] = useState<string>("");
  const [showAprovals, setShowAprovals] = useState<boolean>(false);


  const handleGetFolder = async (idFolder: number) => {
    //
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/documents/folders/get',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({
          isAproved: -1, idFolder: idFolder
        })
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.documents) {
        setDocuments(data.documents);
        //setRoute([{ text: "Inicio", href: "#members/etc/docs" }, ...newRoute]);
      }
      data.aprovals ?
        setAprovals(data.aprovals.map((item: any) => ({
          name: item.fileName,
          extension: item.fileType,
          fileSize: (item.fileSize / 1024).toFixed(2),
          idFile: item.idFile,
          idFolder: item.idFolder,
          isPublic: item.isPublicFile,
          idUser: item.idUser,
          dateCreated: item.datePublish.split(" ")[0],
          timeCreated: item.datePublish.split(" ")[1],
          type: "file",
        }))
        )

        : setAprovals([]);

      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteFolder = async (idFolderDelete: number) => {
    try {
      try {
        setLoading(true);
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/documents/folders/delete',
            'JWT': getCookie("JWT"),
          },

          body: JSON.stringify({
            idFolder: idFolder,
            isAproved: -1,
            idFolderDelete: idFolderDelete,
          })
        });
        if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

        const data = await response.json();
        if (data && data.documents) { setDocuments(data.documents) }
      } catch (error) {
        console.error('Error fetching users:', error);
      } finally {
        setLoading(false);
      }
    } catch (error) {
      console.error('Error reading files:', error);
      // Handle error state if necessary
    }
  };
  const handleFileDelete = async (idFile: number) => {
    try {
      try {
        setLoading(true);
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/documents/files/delete',
            'JWT': getCookie("JWT"),
          },

          body: JSON.stringify({
            idFile: idFile,
            idFolder: idFolder,
            isAproved: -1,
          })
        });
        if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

        const data = await response.json();
        if (data && data.documents) { setDocuments(data.documents) }
      } catch (error) {
        console.error('Error fetching users:', error);
      } finally {
        setLoading(false);
      }
    } catch (error) {
      console.error('Error reading files:', error);
      // Handle error state if necessary
    }
  };

  const handleFileChange = async (files: File[]) => {
    try {
      // Use Promise.all to concurrently convert all files to Base64
      const base64Results = await Promise.all(files.map(fileToBase64));

      try {
        setLoading(true);
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/documents/files/update',
            'JWT': getCookie("JWT"),
          },

          body: JSON.stringify({
            idFile: 0,
            isAproved: 1,
            idFolder: idFolder,
            fileName: files[0].name,
            fileType: files[0].name.split('.').pop()?.toLocaleLowerCase() || "",
            fileSize: files[0].size,
            file: base64Results[0].base64, // assuming single file upload
          })
        });
        if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

        const data = await response.json();
        if (data && data.documents) { setDocuments(data.documents) }
      } catch (error) {
        console.error('Error fetching users:', error);
      } finally {
        setLoading(false);
      }
    } catch (error) {
      console.error('Error reading files:', error);
      // Handle error state if necessary
    }
  };
  const handleUpdateFile = async () => {

    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/documents/files/update',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify(file)
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.documents) {
        setFile(null)
        setMasterFolders(data.documents);
      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleMoveFile = async (tempFile: any) => {

    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/documents/files/update',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify(tempFile)
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.documents) {
        setMoveFile(undefined)
        handleGetFolder(idFolder)
      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };


  const handleMoveFolder = async (tempFolder: any) => {

    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/documents/folders/update',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify(tempFolder)
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.documents) {
        setMoveFolder(undefined)
        handleGetFolder(idFolder)
      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleCreateFolder = async () => {

    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/documents/folders/update',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify(folder)
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.documents) {
        setFolder(null)
        setMasterFolders(data.documents);
      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleGetDocuments = async () => {

    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/documents/list',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({})
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.documents) {
        setMasterFolders(data.documents);
      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  const mountedRef = useRef(false);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      if (id !== null) {
        if (!mountedRef.current) {
          mountedRef.current = true;
          handleGetDocuments()
        }
        setIdFolder(id ? parseInt(id) : 0);
      }
      else {
        setIdFolder(43486)
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, [folders]);


  useEffect(() => {

    if (idFolder > 0) {
      handleGetFolder(idFolder)
      const breadcrumbs = buildBreadcrumbPath(masterFolders, idFolder);
      setRoute(breadcrumbs)
    }
  }, [idFolder, folders, masterFolders]);

  useEffect(() => {
    handleGetDocuments()
  }, []);
  useEffect(() => {
    //const [filteredDocs] = filterTree(documents, keyword);
    //setNewDocuments(filteredDocs);
  }, [keyword]);
  const [
    expandedItems,
    setExpandedItems
  ] = React.useState<ItemDocument[]>([]);


  const filteredDocuments = keyword.length > 1
    // Check if the trimmed keyword is 2 characters or more, OR if searchWords has any content
    ? masterFolders.filter(folder => {
      const searchWords = keyword.trim().toLowerCase().split(/\s+/).filter(Boolean);
      // Prepare the folder name outside the loop for slight performance gain
      const folderNameLower = folder.name.trim().toLowerCase();

      const matchesKeyword = searchWords.every(word =>
        folderNameLower.includes(word)
      );
      return matchesKeyword;
    })
    : [];

  const selectOptions = useMemo(() => {
    // 1. Create a map of all items and build children arrays
    const onlyFolders = masterFolders.filter(item => item.type === 'folder');

    const itemMap: Record<number, { item: FlatFolder; children: number[] }> = {};
    const rootIds: number[] = [];

    // Initialize map
    onlyFolders.forEach(folder => {
      itemMap[folder.idFolder] = { item: folder, children: [] };
    });

    // Populate children arrays or identify roots
    onlyFolders.forEach(folder => {
      const parentId = folder.idParent;
      // If the parent exists in our list, add this folder as its child
      if (parentId && itemMap[parentId]) {
        itemMap[parentId].children.push(folder.idFolder);
      } else {
        // Otherwise, it's a root-level folder
        rootIds.push(folder.idFolder);
      }
    });

    // 2. Recursively traverse the tree to build the flat options list with indentation
    const options: SelectOption[] = [];

    const traverse = (folderId: number, depth: number) => {
      const current = itemMap[folderId];
      if (!current) return;

      // Generate spaces based on depth. 
      // '\u00A0' is a non-breaking space ( ) which HTML selects won't collapse.
      const indentation = '.'.repeat(depth * 2);

      options.push({
        label: `${indentation}${current.item.name}`,
        value: current.item.idFolder
      });

      // Process children deeper down the tree
      current.children.forEach(childId => traverse(childId, depth + 1));
    };

    // Start traversal from each root folder
    rootIds.forEach(rootId => traverse(rootId, 0));

    return options;
  }, [masterFolders]);
  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
          <SpaceBetween size="s">
            <Header variant="h1" actions={<><Favorites /></>}
              info={aprovals.length > 0 ? <Popover triggerType="custom" dismissButton={false} header='Pendientes' content={<>Hay {aprovals.length} documentos pendientes de aprobación. <Link onClick={() => { setShowAprovals(true) }}>Comprobar</Link></>}><Icon path={mdiFileCloud} size={1} color={"red"} /></Popover> : ""}
            >Maestro de documentos</Header>

            <Table
              wrapLines
              header={<BreadcrumbGroup items={route} />}
              filter={
                <SpaceBetween direction="horizontal" size="xs">
                  <div style={{ width: "300px" }}>
                    <Autosuggest
                      hideEnteredTextOption
                      disableBrowserAutocorrect
                      onSelect={(event) => {
                        const item = masterFolders.find((folder) => folder.id === Number(event.detail.selectedOption?.value))
                        if (item && event) {
                          window.location.hash = `${root}?id=${item?.idFolder}`
                          setKeyword(event.detail.selectedOption?.label || "");
                        }
                      }}
                      onChange={({ detail }) => setKeyword(detail.value)}
                      value={keyword}
                      filteringType='manual'
                      options={filteredDocuments.map((item) => ({
                        value: item.id.toString(),
                        label: item.name
                      }))}
                      placeholder="Buscar documentos por palabras clave"
                    />
                  </div>
                  <FileUpload
                    onChange={({ detail }) => {
                      handleFileChange(detail.value);
                    }}
                    accept='.jpeg,.jpg,.cup,.doc,.docx,.xls,.xlsx,.pdf,.ppt,.pptx,.zip,.rar'
                    i18nStrings={{
                      uploadButtonText: e => "",
                      dropzoneText: e => "Arrastre archivo para cargar",
                      removeFileAriaLabel: e => `Eliminar archivo ${e + 1}`,
                      limitShowFewer: "Show fewer files",
                      limitShowMore: "Show more files",
                      errorIconAriaLabel: "Error",
                      warningIconAriaLabel: "Warning"
                    }}
                    showFileLastModified
                    showFileSize
                    showFileThumbnail
                    tokenLimit={1} value={[]} />

                  <Button
                    style={{ root: btnIconForm }}
                    onClick={() => {
                      setFolder({
                        idFolder: 0,
                        ordenFolder: 0,
                        isReadFolder: 1,
                        isActiveFolder: 1,
                        isDeleteFolder: 0,
                        folder: "",
                        idParentFolder: idFolder,
                        isPublicFolder: 0,
                        filesInFolder: 0,
                        foldersInFolder: 0
                      })
                    }}>
                    <Icon path={mdiFolderPlusOutline} size={1} />
                  </Button>
                </SpaceBetween>
              }
              stickyHeader
              variant='embedded'
              columnDefinitions={[
                {
                  id: 'icon',
                  header: '',
                  cell: item => item.type === "folder" ? <Icon path={mdiFolderOutline} size={1} /> :
                    item.extension === "pdf" ? <Icon path={mdiFilePdfBox} size={1} /> :
                      item.extension === "doc" || item.extension === "docx" ? <Icon path={mdiFileWordBox} size={1} /> :
                        item.extension === "xls" || item.extension === "xlsx" ? <Icon path={mdiFileExcelBox} size={1} /> :
                          item.extension === "zip" || item.extension === "rar" ? <Icon path={mdiZipBox} size={1} /> :
                            item.extension === "cup" || item.extension === "igc" ? <Icon path={mdiFileCloud} size={1} /> :
                              item.extension === "ppt" || item.extension === "pptx" ? <Icon path={mdiFilePowerpointBox} size={1} /> : <Icon path={mdiFile} size={1} />

                  ,
                  maxWidth: 50,
                  width: 50,
                },

                // Corrected Column Definition
                {
                  id: 'name',
                  header: 'Nombre',
                  cell: item => item.type === "folder" ? (
                    // Case 1: Folder (returns a Link component)
                    <Link variant="secondary" href={`${root}?id=${item.idFolder}`}>
                      <strong>{item.name}</strong>
                    </Link>
                  ) : (
                    // Case 2: File/Item (returns a Fragment with the name and the Icon)
                    <>
                      {item.name}{' '}
                      {item.isPublic === 1 ? (
                        <Icon path={mdiLockOpenAlertOutline} color={"red"} size={1} />
                      ) : (
                        <Icon path={mdiLockCheckOutline} size={1} />
                      )}
                    </>
                  ),
                },
                {
                  id: 'size',
                  header: 'Tamaño',
                  cell: item => item.type === "folder" ? "" : `${item.fileSize} KB`,
                  width: 50,
                },
                // Column definition for the 'name' field
                {
                  id: 'date',
                  header: 'Fecha',
                  cell: item => item.type === "folder" ? "" : <FormField label={item.dateCreated}>{item.timeCreated}</FormField>,
                  width: 120,
                },
                {
                  id: 'action',
                  header: '',
                  cell: item => item.type === "folder" ?
                    <ButtonDropdown
                      onItemClick={(click) => {
                        if (click.detail.id === "delete") {
                          setDeleteFolder({
                            idFolder: item.idFolder,
                            folder: item.name,
                            isActiveFolder: 1,
                            isDeleteFolder: 0,
                            idParentFolder: item.idParent,
                            isPublicFolder: item.isPublic,
                          })
                        } else if (click.detail.id === "move") {
                          setMoveFolder({
                            idFolder: item.idFolder,
                            folder: item.name,
                            isActiveFolder: 1,
                            isDeleteFolder: 0,
                            idParentFolder: item.idParent,
                            isPublicFolder: item.isPublic,
                          })

                        } else if (click.detail.id === "modify") {
                          setOFiles([]);
                          setFolder({
                            idFolder: item.idFolder,
                            folder: item.name,
                            isActiveFolder: 1,
                            isDeleteFolder: 0,
                            idParentFolder: item.idParent,
                            isPublicFolder: item.isPublic,
                          })
                        }
                      }}
                      expandToViewport
                      items={[
                        { id: "modify", text: "Modificar" },
                        { id: "move", text: "Mover" },
                        { id: "delete", text: "Eliminar", disabled: item.objects > 0, disabledReason: item.objects > 0 ? "La carpeta no está vacía" : "" },
                      ]}
                      variant="icon"
                    />
                    :
                    <ButtonDropdown
                      expandToViewport
                      onItemClick={(click) => {
                        if (click.detail.id === "delete") {
                          setDeleteFile(item);
                        } else if (click.detail.id === "move") {
                          setMoveFile(
                            {
                              idFile: item.idFile,
                              fileName: item.name,
                              fileType: item.extension,
                              idFolder: item.idFolder,
                              isActiveFile: 1,
                              isDeleteFile: 0,
                              datePublish: item.dateCreated + " " + item.timeCreated,
                              isPublicFile: item.isPublic,
                              isAproved: 1,
                              fileSize: parseInt(item.fileSize)
                            })
                        } else if (click.detail.id === "modify") {
                          setOFiles([]);
                          setFile(
                            {
                              idFile: item.idFile,
                              fileName: item.name,
                              fileType: item.extension,
                              idFolder: item.idFolder,
                              isActiveFile: 1,
                              isDeleteFile: 0,
                              datePublish: item.dateCreated + " " + item.timeCreated,
                              isPublicFile: item.isPublic,
                              isAproved: 1,
                              fileSize: parseInt(item.fileSize)
                            }
                          )
                        }
                      }}
                      items={[
                        { id: "modify", text: "Modificar" },
                        { id: "move", text: "Mover" },
                        { id: "delete", text: "Eliminar" },
                      ]}
                      variant="icon"
                    />
                  ,
                  width: 40,
                },
              ]} items={documents}
            />
            {!!deleteFolder && (
              <Confirm type="warning" show={!!deleteFolder} action={'Eliminar carpeta'} warning={`Eliminar carpeta ${deleteFolder.folder}. Esta acción no es reversible`}
                onDismiss={() => setDeleteFolder(undefined)}
                onConfirm={() => {
                  handleDeleteFolder(deleteFolder.idFolder)
                }} />
            )}
            {!!deleteFile && (

              <Confirm type="warning" show={!!deleteFile} action={'Eliminar archivo'} warning={`Eliminar archivo ${deleteFile.name}. Esta acción no es reversible`}
                onDismiss={() => setDeleteFile(undefined)}
                onConfirm={() => {
                  handleFileDelete(deleteFile.idFile)
                }} />
            )}

            <Modal size="medium" onDismiss={() => { setFolder(null); }} visible={folder !== null}
              header={<Header variant='h2'>{folder && folder?.idFolder > 0 ? "Modificar carpeta" : "Crear nueva carpeta"}</Header>}
            >
              <Form
                actions={
                  <Button variant="primary"
                    disabled={folder?.folder.trim().length === 0}
                    onClick={() =>
                      handleCreateFolder()
                    }>Guardar carpeta</Button>}
                secondaryActions={<Button onClick={() => setFolder(null)}>Cancelar</Button>}
              >
                <SpaceBetween direction="vertical" size="xs">
                  <FormField label="Nombre de la carpeta">
                    <Input value={folder?.folder || ""} onChange={(e) => setFolder({ ...folder!, folder: e.detail.value })} />
                  </FormField>
                  <FormField label="Es pública">
                    <RadioGroup
                      direction='horizontal'
                      value={folder?.isPublicFolder.toString() || "0"}
                      onChange={(e) => setFolder({ ...folder!, isPublicFolder: parseInt(e.detail.value) })}
                      items={[
                        { value: "1", label: "Sí" },
                        { value: "0", label: "No" },
                      ]}
                    />
                  </FormField>
                </SpaceBetween>

              </Form>


            </Modal>
            {!!moveFile && (
              <Modal size="medium" onDismiss={() => { setMoveFile(null); }} visible={!!moveFile}
                header={<Header
                  description={moveFile.fileName}
                  variant='h2'>Mover archivo </Header>}

              >
                <Form actions={
                  <Button variant="primary"
                    disabled={file?.fileName.trim().length === 0}
                    onClick={() => {
                      let tempFile = { idFile: moveFile.idFile, idFolder: moveFile.idFolder };
                      handleMoveFile(tempFile);

                    }}>Mover</Button>
                }
                  secondaryActions={<Button onClick={() => setMoveFile(null)}>Cancelar</Button>}
                >
                  {!!selectOptions && (
                    <SpaceBetween direction="vertical" size="xs">
                      <FormField label="Desde">
                        <BreadcrumbGroup items={route} />

                      </FormField>
                      <FormField label="Carpeta destino">
                        <Select
                          selectedOption={selectOptions.map(option => ({

                            label: option.label,
                            value: option.value.toString()
                          })).find(option => parseInt(option.value) === moveFile.idFolder)}

                          onChange={(e) => {
                            setMoveFile({ ...moveFile!, idFolder: parseInt(e.detail.selectedOption?.value || "0") })
                          }}

                          options={selectOptions.map(option => ({
                            label: option.label,
                            value: option.value.toString()

                          }))
                          }
                        />
                      </FormField>
                    </SpaceBetween>
                  )}
                </Form>


              </Modal>
            )}

            {!!moveFolder && (
              <Modal size="medium" onDismiss={() => { setMoveFolder(null); }} visible={!!moveFolder}
                header={<Header variant='h2' description={moveFolder.folder}>Mover carpeta</Header>}

              >
                <Form actions={
                  <Button variant="primary"
                    disabled={file?.fileName.trim().length === 0}
                    onClick={() => {
                      let tempFile = { idParentFolder: moveFolder.taregtIdFolder, idFolder: moveFolder.idFolder };

                      handleMoveFolder(tempFile);

                    }}>Mover</Button>
                }
                  secondaryActions={<Button onClick={() => setMoveFolder(null)}>Cancelar</Button>}
                >
                  {!!selectOptions && (
                    <SpaceBetween direction="vertical" size="xs">
                      <FormField label="Carpeta destino">
                        <Select
                          selectedOption={selectOptions.map(option => ({

                            label: option.label,
                            value: option.value.toString()
                          })).find(option => parseInt(option.value) === moveFolder.idFolder)}

                          onChange={(e) => {
                            setMoveFolder({ ...moveFolder!, taregtIdFolder: parseInt(e.detail.selectedOption?.value || "0") })
                          }}

                          options={selectOptions.map(option => ({
                            label: option.label,
                            value: option.value.toString()

                          }))
                          }
                        />
                      </FormField>
                    </SpaceBetween>
                  )}
                </Form>


              </Modal>
            )}

            <Modal size="medium" onDismiss={() => { setFile(null); }} visible={file !== null}
              header={<Header variant='h2'>Actualizar archivo</Header>}

            >
              <Form actions={
                <Button variant="primary"
                  disabled={file?.fileName.trim().length === 0}
                  onClick={() =>
                    handleUpdateFile()
                  }>Actualizar archivo</Button>
              }
                secondaryActions={<Button onClick={() => setFile(null)}>Cancelar</Button>}
              >
                {file && (
                  <SpaceBetween direction="vertical" size="xs">
                    <FormField label="Nombre del archivo">
                      <Input value={file?.fileName || ""} onChange={(e) => setFile({ ...file!, fileName: e.detail.value })} />
                    </FormField>
                    <FormField label="Es pública">
                      <RadioGroup
                        direction='horizontal'
                        value={file?.isPublicFile?.toString() || "0"}
                        onChange={(e) => setFile({ ...file!, isPublicFile: parseInt(e.detail.value) })}
                        items={[
                          { value: "1", label: "Sí" },
                          { value: "0", label: "No" },
                        ]}
                      />

                      <FileUpload
                        onChange={async ({ detail }) => {
                          if (oFiles.length === 1 && detail.value.length === 0) {
                            setFile({ ...file!, file: "", fileType: "", fileSize: 0 });
                            setOFiles([]);
                            return
                          }
                          if (oFiles.length > 0) {
                            return;
                          }



                          const base64Results = await Promise.all(detail.value.map(fileToBase64));
                          setFile({
                            ...file!, fileName: detail.value[0].name,
                            fileType: detail.value[0].name.split('.').pop()?.toLocaleLowerCase() || "",
                            fileSize: detail.value[0].size,
                            file: base64Results[0].base64, // assuming single file upload

                          })
                          oFiles.push(...detail.value);
                          setOFiles([...oFiles]);
                        }}
                        accept='.jpeg,.jpg,.cup,.doc,.docx,.xls,.xlsx,.pdf,.ppt,.pptx,.zip,.rar'
                        i18nStrings={{
                          uploadButtonText: e => "Sobreescribir archivo",
                          dropzoneText: e => "Arrastre archivo para cargar",
                          removeFileAriaLabel: e => `Eliminar archivo ${e + 1}`,
                          limitShowFewer: "Show fewer files",
                          limitShowMore: "Show more files",
                          errorIconAriaLabel: "Error",
                          warningIconAriaLabel: "Warning"
                        }}
                        showFileLastModified
                        showFileSize
                        showFileThumbnail
                        tokenLimit={1}
                        value={oFiles} />
                    </FormField>

                  </SpaceBetween>
                )}
              </Form>


            </Modal>

            <Modal size="max" onDismiss={() => { setShowAprovals(false); }} visible={showAprovals}
              header={<Header variant='h2'>Aprobar documentos</Header>}
              footer={
                <>
                  <Button variant='link' onClick={() => setShowAprovals(false)}>Cancelar</Button>
                </>

              }
            >
              <Form>

                <Table
                  wrapLines

                  stickyHeader
                  variant='embedded'
                  columnDefinitions={[
                    {
                      id: 'icon',
                      header: '',
                      cell: item => item.type === "folder" ? <Icon path={mdiFolderOutline} size={1} /> :
                        item.extension === "pdf" ? <Icon path={mdiFilePdfBox} size={1} /> :
                          item.extension === "doc" || item.extension === "docx" ? <Icon path={mdiFileWordBox} size={1} /> :
                            item.extension === "xls" || item.extension === "xlsx" ? <Icon path={mdiFileExcelBox} size={1} /> :
                              item.extension === "zip" || item.extension === "rar" ? <Icon path={mdiZipBox} size={1} /> :
                                item.extension === "cup" || item.extension === "igc" ? <Icon path={mdiFileCloud} size={1} /> :
                                  item.extension === "ppt" || item.extension === "pptx" ? <Icon path={mdiFilePowerpointBox} size={1} /> : <Icon path={mdiFile} size={1} />

                      ,
                      maxWidth: 50,
                      width: 50,
                    },

                    // Corrected Column Definition
                    {
                      id: 'name',
                      header: 'Nombre',
                      cell: item =>
                        <FormField label={item.name}>
                          {getUser(item?.idUser || 0, data)?.displayName}
                        </FormField>,
                    },
                    {
                      id: 'size',
                      header: 'Tamaño',
                      cell: item => `${item.fileSize} KB`,
                      width: 50,
                    },
                    // Column definition for the 'name' field
                    {
                      id: 'date',
                      header: 'Fecha',
                      cell: item => <FormField label={item.dateCreated}>{item.timeCreated}</FormField>,
                      width: 120,
                    },
                    {
                      id: 'action',
                      header: '',
                      cell: item =>
                        <ButtonDropdown
                          expandToViewport
                          onItemClick={(click) => {
                            if (click.detail.id === "delete") {
                              handleFileDelete(item.idFile)
                            } else if (click.detail.id === "approve") {
                            }
                          }}
                          items={[
                            { id: "download", text: "Descargar" },
                            { id: "approve", text: "Aprobar" },
                            { id: "delete", text: "Eliminar" },
                          ]}
                          variant="icon"
                        />
                      ,
                      width: 40,
                    },
                  ]} items={aprovals}
                />

              </Form>


            </Modal>
          </SpaceBetween>
        </>
      }
    />
  );
};


function buildBreadcrumbPath(folders: any[], targetId: number) {
  const map = new Map(folders.map(f => [f.id, f]));
  const path = [];
  let current = map.get(targetId);
  while (current) {
    path.unshift({ text: current.name, href: `${root}?id=${current.id}` });
    current = map.get(current.idParent);
  }

  return path;
}